import { Component, Input, Output, EventEmitter, HostBinding, SimpleChanges, ViewChild, ElementRef, Renderer2, OnInit, OnChanges, OnDestroy }
	from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { BbSelectOption } from 'app/components/shared/bb-select/bb-select.component';
import { MatOption } from '@angular/material/core';
import { BbEntitySelectorComponent } from 'app/components/shared/bb-entity-selector/bb-entity-selector.component';
import { BbMacrosService } from 'app/services/bb-macros.service';
import { Subscription } from 'rxjs';

@Component({
	selector: 'ie-form-field',
	templateUrl: './ie-form-field.component.html',
	styleUrls: ['./ie-form-field.component.scss']
})

export class IeFormFieldComponent implements OnChanges, OnDestroy {
	@Input() label: string;
	@Input() suffix: string;
	@Input() useMacroSuggestions = false;
	@Input() disabledMacroHotkey = false;
	@Input() useDataSource: boolean;
	@Input() dataSourceActive: boolean;
	@Input() warningMessage = '';
	@Input() allowMaximize = false;
	@Input() hideUI = false;
	@Output() onChange: EventEmitter<any> = new EventEmitter<any>();
	@Output() dataSourceClicked: EventEmitter<any> = new EventEmitter<any>();
	@HostBinding('style') hostStyle: SafeStyle = null;
	@HostBinding('class.hide-ui') get hideInterface() {
		return this.hideUI;
	}

	@ViewChild('contentWrapper', { static: true }) contentWrapper: ElementRef;
	@ViewChild('suggestionES') suggestionES: BbEntitySelectorComponent;

	suggestOptions: BbSelectOption[];
	suggestionsOpen = false;
	keyDownListener: any;
	filteredAutoCompleteOptions: MatOption[];
	macroOptions: any[];
	macroSubscription: Subscription;
	suggestionKeyUsed: string;

	constructor(
		private sanitizer: DomSanitizer,
		private bbMacrosService: BbMacrosService,
		private renderer: Renderer2
	) {
	}

	onDataSourceButtonClick(model: any) {
		this.dataSourceClicked.emit(model);
	}

	onSuggestionsButtonClick() {
		if (this.suggestionsOpen) {
			this.suggestionsOpen = false;
		} else {
			this.showSuggestions();
		}
	}

	initMacroSuggestions() {
		if (!this.macroSubscription) {
			this.macroSubscription = this.bbMacrosService.macroSubject.subscribe((macroOptions) => {
				this.suggestOptions = macroOptions;
			});
			this.keyDownListener = this.renderer.listen(this.contentWrapper.nativeElement, 'keydown', (ev: KeyboardEvent) => {
				if (ev.key === '{' && !this.disabledMacroHotkey) {
					this.showSuggestions(ev.key);
				}
			});
		}
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.useMacroSuggestions && changes.useMacroSuggestions.currentValue && !this.macroSubscription) {
			this.initMacroSuggestions();
		}
	}

	ngOnDestroy() {
		if (this.keyDownListener) {
			this.keyDownListener();
		}
		if (this.macroSubscription) {
			this.macroSubscription.unsubscribe();
		}
	}

	onContentClick() {
		this.suggestionsOpen = false;
	}

	showSuggestions(keyUsed?: string) {
		this.suggestionsOpen = true;
		if (this.suggestionES) {
			if (keyUsed) {
				this.suggestionKeyUsed = keyUsed;
			} else {
				this.suggestionKeyUsed = null;
			}
			this.suggestionES.open();
		}
	}

	suggestionSelected(suggestOption: any) {
		const inputEl = this.contentWrapper && this.contentWrapper.nativeElement
			&& this.contentWrapper.nativeElement.querySelector('input,textarea,bb-entity-selector');

		if (inputEl) {
			let value = suggestOption.value;
			if (this.suggestionKeyUsed && typeof value === 'string' && value.startsWith(this.suggestionKeyUsed)) {
				value = value.substr(1);
			}
			inputEl.value = (inputEl.value || '') + value;
			if (inputEl.tagName === 'BB-ENTITY-SELECTOR') {
				inputEl.setAttribute('value', inputEl.value);
			}
			this.suggestionsOpen = false;
			inputEl.focus();
			const inputEv = new Event('input', {
				bubbles: true,
				cancelable: true,
			});
			const changeEv = new Event('change', {
				bubbles: true,
				cancelable: true,
			});
			inputEl.dispatchEvent(inputEv);
			inputEl.dispatchEvent(changeEv);
			this.suggestionKeyUsed = null;
		}
	}

	toggleFullSize() {
		this.hostStyle = !this.hostStyle ? this.sanitizer.bypassSecurityTrustStyle(`
		position: fixed;
		left: 50px;
		right: 50px;
		top: 50px;
		z-index: 99999999999999999;
		width: calc(100% - 150px);
		height: calc(100% - 150px);
		`) : null;
	}
}
